/* eslint-disable import/no-default-export */
import createKeywordSuggestion from './createKeywordSuggestion';

const mockSuggestions = [
  'chef',
  'chemist warehouse',
  'chemist',
  'chef cook',
  'chemistry',
];

export default {
  suggestions: (...args: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const [, , , { variableValues }] = args;
    const { keyword } = variableValues as Record<string, string>;

    return keyword.length === 0
      ? []
      : mockSuggestions
          .filter((s) => s.toLowerCase().indexOf(keyword.toLowerCase()) >= 0)
          .map((s) => createKeywordSuggestion(keyword, s));
  },
};
